<template>
  <v-container>
    <GoBackAtTop
      v-if="$route.params && $route.params.show_back_roller"
      :to="{name: 'CompanyEmployeesPermissions', params: {id: $route.params.id}}"
      :label="$t('labels.roles')"
    />
    <GoBackAtTop
      v-else
      :to="{
        name: 'CompanyEmployeePermissions',
        meta: {preferLastPath: true},
        params: {id: $route.params.id, employee_id: $route.params.employee_id}
      }"
      :label="$t('fields.instructor')"
    />
    <div class="title-icon mt-8">
      <h1 v-if="employee.firstName">{{ employee | displayName }}</h1>
      <h5 v-else-if="employee.email">{{ employee.email }}</h5>
    </div>

    <div class="mb-6" v-if="getRoleDescription(employee, hasDepartments($route.params.id)) != ''">
      <v-icon class="icon-24 mr-2">{{ getRoleAvatar(employee, hasDepartments($route.params.id)) }}</v-icon>
      <span v-if="empDeps.departmentAdministrator_deps && empDeps.departmentAdministrator_deps.length>0">{{$t('roles.dep-admin')}} ({{empDeps.departmentAdministrator_deps.map( m => m.name).join(', ')}}) <br></span>      
      <span v-if="empDeps.companyEducationResponsible_deps && empDeps.companyEducationResponsible_deps.length>0">{{$t('labels.yua')}} ({{empDeps.companyEducationResponsible_deps.map( m => m.name).join(', ')}}) <br></span>
      <span v-if="empDeps.distanceEducationAdministrator_deps && empDeps.distanceEducationAdministrator_deps.length>0">{{$t('roles.DistanceEducationAdministrator')}} ({{empDeps.distanceEducationAdministrator_deps.map( m => m.name).join(', ')}}) <br></span>
      <span v-if="empDeps.instructor_deps && empDeps.instructor_deps.length>0">{{$t('labels.instructor')}} ({{empDeps.instructor_deps.map( m => m.name).join(', ')}})<br></span>      
        <!-- getRoleDescription(employee, hasDepartments($route.params.id), true)  -->
      
    </div>

    <v-tabs v-model="tab">
      <v-tab key="1">{{ $t('company.contact') }}</v-tab>
      <v-tab key="2">
        <v-badge v-if="qualificationTimeReadyForApprovalNotice > 0" color="red" :value="qualificationTimeReadyForApprovalNotice">
          <template v-slot:badge>{{ qualificationTimeReadyForApprovalNotice }}</template>
          {{ $t('company.work') }}
        </v-badge>
        <template v-else>
          {{ $t('company.work') }}
        </template>
      </v-tab>
      <v-tab key="3">{{ $t('company.certificate') }}</v-tab>
      <v-tab key="4" v-if="isAdministrator || isDepartmentAdministrator($route.params.id)">{{
        $t('company.admin')
      }}</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item key="1">
        <CompanyEmployeeContact
          :emp="employee"
          :isEditable="isAdmin($route.params.id)"
          @save="updateEmployee"
        ></CompanyEmployeeContact>
      </v-tab-item>
      <v-tab-item key="2">
        <CompanyEmployeeWorkplace :qualificationTimeNotice="qualificationTimeReadyForApprovalNotice" :emp="employee" :isEditable="isAdmin($route.params.id)"></CompanyEmployeeWorkplace>
      </v-tab-item>
      <v-tab-item key="3">
        <CompanyEmployeeCertificate :emp="employee"></CompanyEmployeeCertificate>
      </v-tab-item>
      <v-tab-item key="4">
        <CompanyEmployeeSettings
          v-if="isAdministrator || isDepartmentAdministrator($route.params.id)"
          @delete="showDelete = true"
          :emp="employee"
        ></CompanyEmployeeSettings>
      </v-tab-item>
    </v-tabs-items>

    <DeleteEmployedModal :type="Boolean(get(employee, 'apprentice', null)) ? 'apprentice' : 'employee'" :show="showDelete" @close="showDelete = false" />
  </v-container>
</template>

<script>
import API from '@/services/api.js'
import GoBackAtTop from '@/components/Common/GoBackAtTop'
import CompanyEmployeeContact from '@/components/Company/CompanyEmployeeContact'
import CompanyEmployeeWorkplace from '@/components/Company/CompanyEmployeeWorkplace'
import CompanyEmployeeCertificate from '@/components/Company/CompanyEmployeeCertificate'
import CompanyEmployeeSettings from '@/components/Company/CompanyEmployeeSettings'
// import EnablableTextFieldWithButtons from '@/components/Common/EnablableTextFieldWithButtons'
// import EnablableTextField from '@/components/Common/EnablableTextField'
import {RulesMixin, CompanyRoles} from '@/components/mixins'

import DeleteEmployedModal from '@/components/Company/DeleteEmployedModal'
import ActionButton from '@/components/Common/ActionButton'
import get from "lodash/get";
import uniq from "lodash/uniq";
import uniqBy from "lodash/uniqBy";
import compact from "lodash/compact";
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
import {mapActions, mapGetters} from 'vuex'
import {forEach} from 'lodash'
import {Utilities} from '@/components/mixins'

// @group Company
// CompanyEmployee component
export default {
  name: 'CompanyEmployee',

  mixins: [RulesMixin, CompanyRoles, Utilities],

  components: {
    CompanyEmployeeContact,
    CompanyEmployeeWorkplace,
    CompanyEmployeeCertificate,
    CompanyEmployeeSettings,
    GoBackAtTop,
    ActionButton,

    DeleteEmployedModal
  },

  data: () => ({
    tab: null,
    maskedPersonalnumber: '',    
    showEmail: true,
    showMobilephone: true,
    wpInitDone: false,
    showDelete: false,
    editable: true,
    model2: null,
    empDeps: {},
    employee: {},
    qualificationTime: null
  }),

  mounted() {
    this.$scrollToTop()
  },
  watch: {
    // 'employee.workplaces': {
    //   handler: function(newVal, oldVal) {
    //     if (this.wpInitDone) {
    //       this.updateEmployeeWorkplace({workplaces: newVal})
    //     }
    //     //- First change is done by initial select
    //     this.wpInitDone = true
    //   },
    //   deep: true
    // }
  },

  created() {
    this.init()
  },
  /**
   * @vuese
   * Used to display fullName
   
   */
  filters: {
    displayName: function (value) {
      if (value.lastName) return value.firstName + ' ' + value.lastName
      else return value.firstName
    }
  },

  computed: {
    ...mapGetters('basic', ['getProfessionById', 'getProfessionNameById', 'basicProfessions']),
    ...mapGetters('currentuser', [
      'currentUser',
      'isApprentice',
      'isAdminUser',
      'isAdministrator',
      'isDepartmentAdministrator',
      'isInstructor',
      'isAdmin'
    ]),

    isQualificationTimeEnded() {
      return this.getTimePercentage(this.qualificationTime?.fromDate, this.qualificationTime?.toDate) >= 100
    },

    qualificationTimeReadyForApprovalNotice() {
      return (this.isQualificationTimeEnded && !this.qualificationTime.isApprovedByInstructor) ? 1 : 0
    }
  },

  methods: {
    get: get,
    /**
     * @vuese
     * Used to call method  getApprenticeById or  getEmployeeById based on route name
     * @arg called with no argument
     */
    init() {
      if (this.$route.params.isApprentice || this.$route.name === 'CompanyApprentice') {
        this.getApprenticeById()
      } else {
        this.getEmployeeById()
      }
    },
    /**
     * @vuese
     * Used to fetch Employee
     * @arg the argument is an integer representing Employee id
     */
    getEmployeeById() {
      API.getEmployee(this.$route.params.employee_id)
        .then(response => {        
          this.empDeps=this.getEmployeeRoles(response.data)          
          this.employee = {
            id: response.data.id,
            firstName: response.data.employed.firstName,
            lastName: response.data.employed.lastName,
            mobilephone: response.data.employed.mobilephone || '',
            email: response.data.employed.email || '',
            isInstructor: response.data.isInstructor,
            isCompanyEducationResponsible: response.data.isCompanyEducationResponsible,
            isDistanceEducationAdministrator: response.data.isDistanceEducationAdministrator,
            isAdministrator: response.data.isAdministrator,
            isProtected: response.data.employed.isProtected,
            roleDescription: response.data.roleDescription,
            departmentEmployments: response.data.departmentEmployments,
            workplaces: this.linkedWorkplaces(response.data),
            instructors: [],
            personId: response.data.personId,
            apprentices: response.data.apprentices,
            departmentEmployments: response.data.departmentEmployments,
            tradeCertificates: response.data.employed.tradeCertificates,
            instructorExemptions: response.data.employed.instructorExemptions,
            machineQualifications: response.data.employed.machinequalifications,
            administratorDepartmentIds: response.data.administratorDepartmentIds,
            educationResponsibleDepartmentIds: response.data.educationResponsibleDepartmentIds,
            distanceEducationAdministratorDepartmentIds: response.data.distanceEducationAdministratorDepartmentIds,
            instructorDepartmentIds: response.data.instructorDepartmentIds,
            personalNumber: response.data.employed.personalNumber,
            maskedPersonalnumber: response.data.employed.personalNumber.substring(0, 8) + '-****',
            readInstructionsOn: response.data.employed.readInstructionsOn
          }
          //this.maskedPersonalnumber = this.employee.personalNumber.substring(0, 8) + '-****'
        })
        .catch(error => {
          console.log('There is no employee for this id, ', error)
        })
    },

    /**
     * @vuese
     * Used to fetch Apprenticeship
     * @arg the argument is an integer representing Employee id
     */
    getApprenticeById() {
      API.getApprenticeship(this.$route.params.employee_id)
        .then(response => { //console.log("getAppr::", response.data)
          let instructors = []

          if (response.data.apprenticeshipInstructors && response.data.apprenticeshipInstructors.length > 0) {
            instructors = response.data.apprenticeshipInstructors.map(o => o.instructor)
          }
          else if (response.data && response.data.instructors && response.data.instructors.length > 0) {
            instructors = response.data.instructors
          }

          this.employee = {
            id: response.data.id,
            firstName: response.data.apprentice.firstName,
            lastName: response.data.apprentice.lastName,
            mobilephone: response.data.apprentice.mobilephone || '',
            email: response.data.apprentice.email || '',
            isInstructor: false,
            personId: response.data.apprentice.id,
            isCompanyEducationResponsible: false,
            isDistanceEducationAdministrator: false,
            isAdministrator: false,
            isProtected: response.data.apprentice.isProtected,
            roleDescription: '',
            type: response.data.type,
            workplaces: this.linkedWorkplaces(response.data),
            instructors: instructors,
            //instructors: response.data.instructors,
            instructorIds: response.data.instructorIds,
            apprentices: [],
            apprentice: true,
            educations: response.data.apprentice.educations,
            professionId: response.data.profession.id,
            tradeCertificates: null,
            instructorExemptions: null,
            machineQualifications: null,
            departmentEmployments: response.data.departmentEmployments,
            personalNumber: response.data.apprentice.personalNumber,
            maskedPersonalnumber: response.data.apprentice.personalNumber.substring(0, 8) + '-****'
          }

          if(this.employee?.type.includes('QualificationTime')) {
            this.getApprenticeQualificationTime()
          }
          //this.maskedPersonalnumber = this.employee.personalNumber.substring(0, 8) + '-****'
        })
        .catch(error => {
          console.log('There is no employee for this id: ', error)
        })
    },
    /**
     * @vuese
     * Used to return workplaces
     */
    linkedWorkplaces(data) {
      let workplaces = []
      if (data.workplaces) {
        data.workplaces.forEach(wp => {
          workplaces.push({
            id: wp.workplaceId,
            name: wp.workplaceaddress.name,
            postalAddress1: wp.workplaceaddress.postalAddress1,
            postalZip: wp.workplaceaddress.postalZip,
            postalCity: wp.workplaceaddress.postalCity
          })
        })
      }
      return workplaces
    },
    /**
     * @vuese
     * Used to get profession icon based on profession id
     */
    getProfessionIcon(id) {
      const prof = this.getProfessionById(Number(id))
      if (prof && prof.icon) {
        return `$sl-${prof.icon}`
      }
      return ''
    },
    /**
     * @vuese
     * Used to make a mailto email and send email directly
     */
    mailtoFunc(email) {
      window.location.href = 'mailto:' + email
    },

    /**
     * @vuese
     * Used to update Employee based on employee its apprentice itself or an employee
     * @arg The argument is an object representing employee
     */
    updateEmployee(emp) {
      // if (!this.$refs.form1.validate()) {
      //   this.$events.fire('showError', 'Formuläret inte ifyllt korrekt')
      //   return
      // }

      if (emp.apprentice) {
        let updateApprenticeData = {
          roleDescription: emp.roleDescription,
          person: {email: emp.email, mobilephone: emp.mobilephone}
        }
        API.updateApprenticeship(emp.id, {data: updateApprenticeData})
          .then(response => {
            this.$events.fire('showInfo', this.$t('success.saved'))
          })
          .catch(error => {
            this.$events.fire('showError', this.$t('errors.save-failure'))
            console.log('There was an error:', error)
          })
      } else {
        let person = {
          roleDescription: emp.roleDescription,
          instructorDepartmentIds: emp.instructorDepartmentIds,
          educationResponsibleDepartmentIds: emp.educationResponsibleDepartmentIds,
          distanceEducationAdministratorDepartmentIds: emp.distanceEducationAdministratorDepartmentIds,
          administratorDepartmentIds: emp.administratorDepartmentIds,
          person: {email: emp.email, mobilephone: emp.mobilephone}
        }

        API.updateEmployment(this.employee.id, {data: person})
          .then(response => {
            this.$events.fire('showInfo', this.$t('success.saved'))
          })
          .catch(error => {
            this.$events.fire('showError', this.$t('errors.save-failure'))
            console.log('There was an error:', error)
          })
      }
    },  
    
    getApprenticeQualificationTime() {
      const personId = this.employee?.personId
      API.getQualifyingTime(personId).then(({ data }) => {
        this.qualificationTime = data.educations[0]?.qualificationTime
      })
    },

    getTimePercentage(start, end) {
      const startDate = new Date(start)
      const endDate = new Date(end)
      const nowDate = new Date()
      const totalTime = endDate - startDate
      const passedTime = nowDate - startDate

      return this.getPercentage(passedTime, totalTime)
    },
  }
}
</script>
